import { createYupSync } from "@lib/helpers/TableHelper";
import { npayexProviderSchema } from "@lib/schemas/provider";
import { Provider } from "@lib/types";
import { Form, Input } from "antd";
import { useIntl } from "react-intl";

type Props = {
  objKey?: string;
  provider: Provider;
};

export default function NpayexProviderFormItems({ objKey }: Props) {
  const { messages } = useIntl();

  return (
    <>
      <Form.Item
        name={[objKey, "baseUrl"]}
        label={messages["common.baseUrl"] as string}
        rules={[createYupSync({ schema: npayexProviderSchema })]}
        required
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={[objKey, "apiKey"]}
        label={messages["common.apiKey"] as string}
        rules={[createYupSync({ schema: npayexProviderSchema })]}
        required
      >
        <Input />
      </Form.Item>
    </>
  );
}
